import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";
import { Link, useHistory } from "react-router-dom";

import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  Spinner,
  Alert,
} from "reactstrap";

// import images
import profileImg from "../../assets/images/profile-img.png";
import logo from "../../assets/images/brands/logo-sm-light.png";

//i18n
import { withTranslation } from "react-i18next";
import ProfilePicture from "../../components/Common/ProfilePicture";

import { loginUser, logoutUser } from "../../store/auth/login/actions";

const LockScreen = ({ t }) => {
  const [data, setData] = useState({});
  const dispatch = useDispatch();
  const history = useHistory();
  const { error, loading } = useSelector((state) => state.Login);

  const handleValidSubmit = async (event, values) => {
    values.slug = data.company;
    values.email = data.email;
    dispatch(loginUser(values, history));
  };

  const handleLogout = () => {
    dispatch(logoutUser(history));
  };

  useEffect(() => {
    delete axios.defaults.headers.common["Authorization"];
    if (localStorage.getItem("lastUser")) {
      setData(JSON.parse(localStorage.getItem("lastUser")));
    } else {
      handleLogout();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md="8" lg="6" xl="5">
              <Card className="overflow-hidden">
                <div className="bg-soft-primary">
                  <Row>
                    <Col xs="7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">{t("Lock screen")}</h5>
                        <p>{t("Enter your password to unlock the screen!")}</p>
                      </div>
                    </Col>
                    <Col xs="5" className="align-self-end">
                      <img
                        src={profileImg}
                        alt="main-pic"
                        className="img-fluid"
                      />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt="Tech4H"
                            className="rounded-circle"
                            height="50"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <AvForm
                      className="form-horizontal"
                      onValidSubmit={handleValidSubmit}
                    >
                      <div className="user-thumb text-center mb-4">
                        {data.url_avatar !== null ? (
                          <img
                            src={data.url_avatar}
                            className="rounded-circle img-thumbnail avatar-md"
                            alt="profile-pic"
                          />
                        ) : (
                          <ProfilePicture name={data.name} sizePx={72} />
                        )}
                        <h5 className="font-size-15 mt-3">{data.name}</h5>
                      </div>
                      {error && (
                        <Alert color="danger">{t(error[0].value)}</Alert>
                      )}

                      <div className="form-group">
                        <AvField
                          className="form-control"
                          name="password"
                          label={t("Password")}
                          type="password"
                          required
                          placeholder={t("Enter your Password")}
                          validate={{
                            required: {
                              value: true,
                              errorMessage: t("Required Field"),
                            },
                            minLength: {
                              value: 4,
                              errorMessage: t("Invalid field"),
                            },
                            maxLength: {
                              value: 30,
                              errorMessage: t("Invalid field"),
                            },
                          }}
                        />
                      </div>

                      <div className="form-group row mb-0">
                        <Col xs="12" className="text-right">
                          {loading ? (
                            <button
                              className="btn btn-primary btn-block waves-effect waves-light"
                              style={{ cursor: "no-drop" }}
                              disabled={true}
                            >
                              <Spinner
                                animation="border"
                                style={{
                                  height: "19px",
                                  width: "19px",
                                }}
                              />
                            </button>
                          ) : (
                            <button
                              color="primary"
                              className="btn btn-primary btn-block waves-effect waves-light"
                              type="submit"
                            >
                              {t("Unlock")}
                            </button>
                          )}
                        </Col>
                      </div>
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  {t("Not you ? return")}
                  <Link
                    to="/login"
                    className="font-weight-medium text-primary"
                    onClick={handleLogout}
                  >
                    {" "}
                    Login{" "}
                  </Link>{" "}
                </p>
                <div className="mt-5 text-center">
                  <p>© {new Date().getFullYear()} Tech4humans.</p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(LockScreen);
